var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.993,
    height: 82,
    viewBox: "0 0 106.993 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(-165.357 -60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M1.533,0V-.966l3.233-.21V-28.786L1.533-29v-.966H13.375V-29l-3.233.21v27.4q3.422.231,4.682.231,1.155,0,2.026-.063a7.758,7.758,0,0,0,1.6-.272,8.494,8.494,0,0,0,1.218-.44,2.938,2.938,0,0,0,.934-.722,5.871,5.871,0,0,0,.714-.963,11,11,0,0,0,.714-1.842A26.882,26.882,0,0,0,22.8-8.566h.714V0Z",
    transform: "translate(221.464 100)",
    fill: "#d8bb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M2.01-14.027a20.081,20.081,0,0,1,.482-4.337A17.789,17.789,0,0,1,4.05-22.651a16.052,16.052,0,0,1,2.6-3.722,11.4,11.4,0,0,1,3.825-2.615,12.561,12.561,0,0,1,5.045-.995,12.365,12.365,0,0,1,6.86,1.764Q25.1-26.455,25.1-24.056a3.145,3.145,0,0,1-.82,2.194,2.9,2.9,0,0,1-2.256.9,2.961,2.961,0,0,1-2.174-.831,2.83,2.83,0,0,1-.841-2.1,2.781,2.781,0,0,1,.882-2.184,3.254,3.254,0,0,1,2.256-.79v-.082a5.54,5.54,0,0,0-1.917-1.169,8.7,8.7,0,0,0-3.476-.636,7.481,7.481,0,0,0-5,1.794A11.029,11.029,0,0,0,8.552-22a22.414,22.414,0,0,0-1.087,7.3q0,1.415.092,2.728a25.233,25.233,0,0,0,.359,2.769A18.769,18.769,0,0,0,8.6-6.521,11.872,11.872,0,0,0,9.721-4.153a8.223,8.223,0,0,0,1.62,1.938A6.972,6.972,0,0,0,13.576-.943a8.5,8.5,0,0,0,2.892.472,13.2,13.2,0,0,0,3.814-.614V-12.243l-3.035-.225v-.943H27.993v.943l-3.015.225V-1.391A14.651,14.651,0,0,1,20.651.165,25.507,25.507,0,0,1,15.34.718Q2.01.718,2.01-14.027Z",
    transform: "translate(244.357 127.88)",
    fill: "#d8bb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M21.839,79.477V65.5C7.195,64.749,0,57.867,0,57.867L16.821,26.062,12.2,7.664a36.6,36.6,0,0,1,9.634-2.589C22.043,2.095,22.719,0,24.774,0c2.074,0,2.743,2.133,2.945,5.157A36.9,36.9,0,0,1,36.7,7.664L31.845,25.623,48.9,57.867S41.645,64.8,26.884,65.508V79.477a2.523,2.523,0,0,1-5.045,0Z",
    transform: "translate(165.357 60)",
    fill: "#d8bb2a"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x1: 30.272,
    y2: 44.398,
    transform: "translate(233.014 78.26)",
    fill: "none",
    stroke: "#d8bb2a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.8db34be262d71eaa2c148a7190a82bd3.svg";
export { ForwardRef as ReactComponent };